import { registerComponent } from "helpers";

registerComponent(
  "preferred-store-inventory-form",
  class PreferredStoreInventoryForm extends HTMLElement {
    connectedCallback() {
      this.preferredStore = JSON.parse(
        window.localStorage.getItem("storeLocation"),
      );

      this.form = this.querySelector("form");

      this.preferredStoreToggle = this.querySelector(
        "[data-preferred-store-inventory-toggle]",
      );

      this.searchParams = new URLSearchParams(window.location.search);
      this.availabilityParam = this.searchParams.get(
        "filter.v.m.wyatt.availability",
      );

      this.preferredStoreToggleLabel = this.querySelector(
        "[data-preferred-store-inventory-toggle-name]",
      );

      if (this.preferredStore) {
        this.setPreferredStoreToggleValue();
        this.showPreferredStoreToggle();

        this.addEventListener("input", this.handleInput.bind(this));
      }

      this.setToggleState();
    }

    setPreferredStoreToggleValue() {
      this.preferredStoreToggle.setAttribute(
        "value",
        this.preferredStore?.name,
      );
    }

    showPreferredStoreToggle() {
      const { preferredStoreToggleLabel } = this;
      const preferredStoreName = this.preferredStore.name;

      this.form.classList.remove("hidden");
      preferredStoreToggleLabel.textContent =
        preferredStoreToggleLabel.textContent
          .replace("xx", preferredStoreName)
          .trim();
    }

    setToggleState() {
      if (this.availabilityParam) {
        this.setCheckedToggleState();
      } else {
        this.setUncheckedToggleState();
      }

      this.displayToggleState();
    }

    setCheckedToggleState() {
      window.localStorage.setItem("preferredStoreInventoryCheck", true);
    }

    setUncheckedToggleState() {
      window.localStorage.setItem("preferredStoreInventoryCheck", false);
    }

    displayToggleState() {
      const preferredStoreInventoryCheck = window.localStorage.getItem(
        "preferredStoreInventoryCheck",
      );

      if (preferredStoreInventoryCheck === "true") {
        this.displayCheckedToggleState();
      } else {
        this.displayUncheckedToggleState();
      }
    }

    displayCheckedToggleState() {
      this.preferredStoreToggle.checked = true;
    }

    displayUncheckedToggleState() {
      this.preferredStoreToggle.checked = false;
    }

    handleInput(event) {
      const formID = event.target.getAttribute("form");
      const form = document.getElementById(formID);
      const preferredStoreInventoryCheck = new CustomEvent("input");

      form.dispatchEvent(preferredStoreInventoryCheck);

      if (this.preferredStoreToggle.checked) {
        this.setCheckedToggleState();
      } else {
        this.setUncheckedToggleState();
      }
    }
  },
);
